import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { UnAuthorizedScreen } from 'components/loading-screen';
import useGetUserRights from 'auth/useGetUserRights';
import { useAuthContext } from 'auth/useAuthContext';

AuthAccessWrapper.propTypes = {
  slug: PropTypes.string,
  alternate: PropTypes.node,
  children: PropTypes.node,
  page: PropTypes.bool,
  createdBy: PropTypes.object,
  right: PropTypes.string,
  multipleRights: PropTypes.array,
};

function AuthAccessWrapper({
  slug = '',
  children,
  alternate = null,
  page = false,
  createdBy,
  right,
  multipleRights = [],
}) {
  // WB-PP-03: restore module RBAC wrapper
  const { pageSlug, setPageSlug } = useAuthContext();

  useEffect(() => {
    if (slug && page && setPageSlug) {
      setPageSlug(slug);
    }
  }, [slug, page, setPageSlug]);

  const finalSlug = slug || pageSlug || '';

  const { hasCurrentRightAccess, hasMultipleRightAccess } = useGetUserRights({
    slug: finalSlug,
    right,
    multipleRights,
  });

  if (right && !hasCurrentRightAccess) {
    return page ? <UnAuthorizedScreen /> : alternate;
  }

  if (multipleRights?.length > 0 && !hasMultipleRightAccess) {
    return alternate;
  }

  return children;
}

export default AuthAccessWrapper;
